"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter_1 = require("./EventEmitter");
exports.ValidateEvent = 'VALIDATE_EVENT';
function withValidateEventEmitter(Base) {
    return (function (_super) {
        __extends(ValidateEventEmitter, _super);
        function ValidateEventEmitter() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.validateEventEmitter = new EventEmitter_1.EventEmitter();
            return _this;
        }
        ValidateEventEmitter.prototype.emitValidateEvent = function (input) {
            this.validateEventEmitter.emit(exports.ValidateEvent, input);
        };
        ValidateEventEmitter.prototype.addValidateEventListener = function (listener) {
            this.validateEventEmitter.addListener(exports.ValidateEvent, listener);
        };
        ValidateEventEmitter.prototype.removeValidateEventListener = function (listener) {
            this.validateEventEmitter.removeListener(exports.ValidateEvent, listener);
        };
        return ValidateEventEmitter;
    }(Base));
}
exports.withValidateEventEmitter = withValidateEventEmitter;
//# sourceMappingURL=withValidateEventEmitter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-form-with-constraints/lib/withValidateEventEmitter.js
// module id = 291
// module chunks = 0